import { Grid, makeStyles } from '@material-ui/core'
import Paper from '@material-ui/core/Paper'
import React from 'react'
import { ImportStructure } from './ImportStructure'
import { ImportTextualisation } from './ImportTextualisation'
import { ImportChat } from './ImportChat'
import { ImportSynthese } from './ImportSynthese'

const ImportData = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <div>
          <Paper elevation={1} style={{ padding: 15 }}>
            <ImportStructure />
            <ImportChat />
            <ImportTextualisation />
            <ImportSynthese />
          </Paper>
        </div>
      </Grid>
    </Grid>
  )
}

export default ImportData
